import React, {FC, ReactElement} from 'react';
import CombosClass from './Combos';
import styled from 'styled-components';
import './Combo.scss';

export type ComboProps = {
    index: number | null,
    path: {
        slideIndex: number,
        comboIndex: number,
        setIndex: number | null,
        groupIndex: number | null,
        elementIndex: number | null,
        subElementIndex: number | null
    } | null,
    editorPlugins: any | null,
    comboData: any,
    isEmptySlide: boolean | null,
}

type ComboDesignedProps = {
    verticalAlignment: string,
    horizontalAlignment: string,
    backgroundColor: string,
    borderColor: string,
    round: string,
    borderWidth: number,
    minHeight: string,
    isCustomHeight: boolean,
    isCustomWidth: boolean,
    maxWidth: string,
    isDraggingOver: boolean
    isDragging: boolean,
    comboName:string
}

type Options = {
    name: string,
    title: string,
    icon: string,
    action: string,
    settingTitle: string,
    condition?: string
}

export const ComboDesigned = styled.div<ComboDesignedProps>`
&.comboWrapper {
     justify-content: ${props => props.horizontalAlignment || 'inherit'}; 
     align-items: ${props => props.verticalAlignment || 'inherit'};
     ${props => props.horizontalAlignment === 'start' && `
        text-align:left;
    `}; 
     ${props => props.horizontalAlignment === 'center' && `
        text-align:center;
    `}; 
     ${props => props.horizontalAlignment === 'end' && `
        text-align:right;
    `}; 
    .inner_wrapper {
        background: ${props => props.backgroundColor};
        justify-content: ${props => props.horizontalAlignment}; 
        align-items: ${props => props.verticalAlignment};
        max-width: 1400px; 
        ${props => props.borderWidth > 0 && `
            border: ${props.borderWidth}px solid ${props.borderColor || 'transparent'};
        `}; 
         border-radius: ${props => props.round ? props.round : '0'};
        ${props => props.minHeight === 'narrow' && !props.isCustomHeight && `
            padding: 0 32px;
       `};
          ${props => (props.minHeight === 'auto' || props.minHeight === 'narrow') && !props.isCustomHeight && `
             min-height: 0; 
         `};
          ${props => props.minHeight === 'screenFit' && !props.isCustomHeight && `
             min-height: 100vh; 
         `};
          ${props => props.isCustomHeight && props.minHeight !== 'auto' && props.minHeight !== 'large' && props.minHeight !== 'small' && props.minHeight !== 'medium' && `
            min-height: ${props.minHeight}px; 
         `};
         ${props => props.maxWidth === 'narrow' && `
            max-width: 720px;  
         `};
         ${props => props.maxWidth === 'medium' && `
             max-width: 1140px; 
         `};
         ${props => props.maxWidth === 'wide' && `
             max-width: 1440px;
         `};    
         ${props => props.maxWidth === 'full' && `
             max-width: 100%;
         `};    
          ${props => props.maxWidth === 'wide' && props.comboName === 'Narrator' && `
             padding:0;
         `};    
         > div {
          ${props => (props.minHeight === 'auto' || props.minHeight === 'narrow') && !props.isCustomHeight && `
             min-height: 0; 
         `};
          ${props => props.minHeight === 'screenFit' && !props.isCustomHeight && `
             min-height: 100vh; 
         `};
          ${props => props.isCustomHeight && props.minHeight !== 'auto' && props.minHeight !== 'large' && props.minHeight !== 'small' && props.minHeight !== 'medium' && `
            min-height: ${props.minHeight}px; 
         `};
         }
    }
}
`;

const Combo: FC<ComboProps> = ({...props}): ReactElement => {

    const combosClass = new CombosClass();
    let Combo = combosClass.getComboClass(props.comboData.name);
    if(!Combo) return <></>;
    const isEditor = props.editorPlugins;
    const index = props.index ? props.index : 0;

    function getComboSettings() {
        switch (props.comboData.name) {
            case 'VTimeline' :
                return timelineSettings;
            case 'Tabs' :
                return tabsSettings;
            case 'Narrator' :
                return narratorSettings;
            default:
                return settings;
        }
    }

    if (isEditor) {
        const ComboEditor = require('./ComboEditor').default;
        let comboSettings = getComboSettings();
        let comboLabel = label[ props.comboData.name ];
        let comboOptions = options[ props.comboData.name ];
        return <ComboEditor {...props} comboElement={Combo} comboSettings={comboSettings} comboOptions={comboOptions} label={comboLabel} />;
    } else {
        return (<ComboDesigned className={'comboWrapper'} key={index} data-index={index} verticalAlignment={props.comboData.settings.verticalAlignment}
                               horizontalAlignment={props.comboData.settings.horizontalAlignment} backgroundColor={props.comboData.settings.backgroundColor}
                               borderColor={props.comboData.settings.borderColor} borderWidth={props.comboData.settings.borderWidth} round={props.comboData.settings.round}
                               minHeight={props.comboData.settings.minHeight} maxWidth={props.comboData.settings.maxWidth} isCustomHeight={props.comboData.settings.isCustomHeight}
                               isCustomWidth={props.comboData.settings.isCustomWidth} isDraggingOver={false} isDragging={false} comboName={props.comboData.name}
                               data-anchor-target={props.comboData.settings.isAnchorActive ? props.comboData.settings.anchorName : ''}>
            <div className="inner_wrapper">
                {
                    <Combo {...props.comboData} editorPlugins={null} index={null} path={null}/>
                }
            </div>
        </ComboDesigned>);
    }
};

export default Combo;

export let settings: any[];
export let timelineSettings: any[];
export let tabsSettings: any[];
export let narratorSettings: any[];
const environmentLink: string|undefined = getEnvironmentLink();
let SettingsData;
try {
    SettingsData = require('../../settings-data').default;
} catch (ex) {
    SettingsData = null;
}
if (SettingsData) {
    const settingsClass = new SettingsData();
    const allSettings = settingsClass.getAllSettings();
    settings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            },
            {
                settingName: 'VerticalAlignment',
            },
        ],
        [
            {
                settingName: 'BackgroundColor',
                controls: [
                    {
                        controlName: 'CustomColors',
                        property: 'backgroundColor',
                        title: '',
                        defaultValue: '#fff',
                    },
                ],
            },
            {
                settingName: 'BorderColor',
            },
            {
                settingName: 'BorderWidth',
            },
            {
                settingName: 'BorderRadius',
            },
        ],
        [
            {
                settingName: 'ElementWidth',
            },
            {
                settingName: 'ElementHeight',
            },
            {
                settingName: 'NumberOfSets',
                title: 'Groups per line',
                enable: {
                    type: 'combo',
                    values: ['Array']
                },
                controls: [
                    {
                        controlName: 'SetsPerLine',
                        property: 'setsPerLine',
                        options: [
                            {
                                title: 'Auto',
                                value: 'auto'
                            },
                            {
                                title: 'Custom',
                                value: 'custom'
                            }
                        ]
                    },
                    {
                        controlName: 'Slider',
                        title: 'Spacing',
                        property: 'setsSpace',
                        defaultValue: '64',
                        useDefaultValue: true,
                        suffix: 'px',
                        min: 0,
                        max: 100,
                        step: 1,
                    },
                ]
            }
        ],
        [
            {
                settingName: 'Anchor',
            }
        ]
    ];
    timelineSettings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            }
        ],
        [
            {
                settingName: 'ComboLine',
                title: 'Line Color',
                icon: environmentLink + '/assets/images/comboLine.svg',
                isShowTitle: false,
                hasDrop: true,
                dropWidth: 'big',
                controls: [
                    {
                        controlName: 'CustomColors',
                        property: 'comboLineColor',
                        title: '',
                        defaultValue: '#000',
                        isGradient: false
                    },
                ],
            },
            {
                settingName: 'ComboDot',
                title: 'Dot Color',
                icon: environmentLink + '/assets/images/comboDot.svg',
                hasDrop: true,
                dropWidth: 'big',
                isShowTitle: false,
                controls: [
                    {
                        controlName: 'CustomColors',
                        property: 'comboDotsColor',
                        title: '',
                        defaultValue: '#000',
                        isGradient: false
                    }
                ],
            },
        ],
        [
            {
                settingName: 'Anchor',
            }
        ]
    ];
    tabsSettings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            }
        ],
        [
            {
                settingName: 'TabsDesign',
                title: 'Tabs design',
                icon: environmentLink + '/assets/images/tabsDesign.svg',
                isShowTitle: false,
                hasDrop: true,
                dropWidth: 'popup',
                removePadding: true,
                controls: [
                    {
                        controlName: 'TabsDesign',
                        property: 'tabsItems',
                        title: 'Tabs design',
                        icon: environmentLink + '/assets/images/tabsDesign.svg'
                    },
                ],
            },
            {
                settingName: 'TabsContent',
                title: 'Tabs content',
                icon: environmentLink + '/assets/images/tabsContent.svg',
                isShowTitle: false,
                hasDrop: true,
                dropWidth: 'popup',
                removePadding: true,
                controls: [
                    {
                        controlName: 'TabsContent',
                        property: 'tabsItems',
                        title: 'Tabs',
                        icon: environmentLink + '/assets/images/tabsContent.svg'
                    },
                ],
            },
            {
                settingName: 'TabsLayout',
                title: 'Tabs layout',
                icon: environmentLink + '/assets/images/tabsLayout.svg',
                isShowTitle: true,
                hasDrop: true,
                dropWidth: 'medium',
                removePadding: false,
                controls: [
                    {
                        controlName: 'ImageSelect',
                        property: 'tabsLayout',
                        title: '',
                        defaultValue: 1,
                        presetData: [
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/Layout-top.svg',
                                value: 'top',
                                width: 25
                            },
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/Layout-bottom.svg',
                                value: 'bottom',
                                width: 25
                            },
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/Layout-left.svg',
                                value: 'left',
                                width: 25
                            },
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/Layout-right.svg',
                                value: 'right',
                                width: 25
                            }
                        ],
                        isCheckButton: true
                    },
                    {
                        controlName: 'ImageSelect',
                        property: 'tabsPerRow',
                        title: 'Tabs per row',
                        defaultValue: 1,
                        presetData: [
                            {
                                title: '1',
                                icon: null,
                                value: 1,
                                width: 20
                            },
                            {
                                title: '2',
                                icon: null,
                                value: 2,
                                width: 20
                            },
                            {
                                title: '3',
                                icon: null,
                                value: 3,
                                width: 20
                            },
                            {
                                title: '4',
                                icon: null,
                                value: 4,
                                width: 20
                            },
                            {
                                title: '5',
                                icon: null,
                                value: 5,
                                width: 20
                            }
                        ],
                        isValuesInsideBox: true,
                        isCheckButton: true
                    },
                    {
                        controlName: 'Toggle',
                        property: 'isShowTabsIcons',
                        title: 'Show icons',
                        defaultValue: true,
                    },
                ]
            },
        ],
        [
            {
                settingName: 'FontSize',
                iconProperty: 'tabsFontSize',
                controls: [
                    {
                        controlName: 'InputSelect',
                        property: 'tabsFontSize',
                        title: '',
                        defaultValue: '14',
                        values: getFontSizeValues()
                    },
                ],
            },
            {
                settingName: 'TitleColor',
                iconProperty: 'tabsColor',
                controls: [
                    {
                        controlName: 'CustomColorsTabs',
                        title: '',
                        defaultValue: '#000',
                        tabs: [
                            {
                                name: 'default',
                                title: 'Default',
                                property: 'tabsColor',
                            },
                            {
                                name: 'hover',
                                title: 'Active',
                                property: 'tabsHoverColor',
                            }
                        ]
                    },
                ]
            },
            {
                settingName: 'ButtonBackgroundColor',
                title: 'Background Color',
                isShowTitle: false,
                icon: environmentLink + '/assets/images/backgroundColor.svg',
                iconType: 'color',
                iconProperty: 'tabsBgColor',
                hasDrop: true,
                dropWidth: 'big',
                removePadding: true,
                removeArrow: true,
                controls: [
                    {
                        controlName: 'CustomColorsTabs',
                        title: '',
                        defaultValue: '#fff',
                        tabs: [
                            {
                                name: 'default',
                                title: 'Default',
                                property: 'tabsBgColor',
                            },
                            {
                                name: 'hover',
                                title: 'Active',
                                property: 'tabsBgHoverColor',
                            }
                        ]
                    },
                ],
            },
            {
                settingName: 'BorderColor',
                iconProperty: 'tabsBorderColor',
                isShowTitle: false,
                controls: [
                    {
                        controlName: 'CustomColorsTabs',
                        title: '',
                        defaultValue: '#fff',
                        isGradient: false,
                        tabs: [
                            {
                                name: 'default',
                                title: 'Default',
                                property: 'tabsBorderColor',
                            },
                            {
                                name: 'hover',
                                title: 'Active',
                                property: 'tabsBorderHoverColor',
                            }
                        ]
                    },
                ],
            },
            {
                settingName: 'BorderWidth',
                controls: [
                    {
                        controlName: 'InputNumber',
                        property: 'tabsBorderWidth',
                        title: 'Border size',
                        defaultValue: 0,
                        min: 0,
                        max: 10
                    },
                ],
            },
            {
                settingName: 'BorderRadius',
                controls: [
                    {
                        controlName: 'ImageSelect',
                        property: 'tabsBorderRadius',
                        title: '',
                        defaultValue: '8px',
                        presetData: [
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/radius0.svg',
                                value: '0',
                                width: 25
                            },
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/radius4.svg',
                                value: '8px',
                                width: 25
                            },
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/radius8.svg',
                                value: '16px',
                                width: 25
                            },
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/radius16.svg',
                                value: '50px',
                                width: 25
                            }
                        ],
                        isCheckButton: true
                    },
                ]
            },
        ],
        [
            {
                settingName: 'TabsSettings',
                title: 'Tabs Settings',
                icon: environmentLink + '/assets/images/PlaySetting.svg',
                isShowTitle: false,
                hasDrop: true,
                dropWidth: 'medium',
                removeArrow: true,
                controls: [
                    {
                        controlName: 'Toggle',
                        property: 'tabsAutoplay',
                        title: 'Autoplay',
                        padding: '0 0 16px',
                        separateLine: true,
                    },
                    {
                        controlName: 'Toggle',
                        property: 'tabsLoop',
                        title: 'Loop',
                        padding: '0 0 16px',
                        separateLine: true,
                    },
                    {
                        controlName: 'ImageSelect',
                        property: 'tabsSpeed',
                        title: 'Speed',
                        defaultValue: 'medium',
                        isValuesInsideBox: true,
                        isCheckButton: true,
                        separateLine: true,
                        padding: '0 0 16px',
                        presetData: [
                            {
                                title: 'Slow',
                                value: 'slow',
                                width: 33
                            },
                            {
                                title: 'Medium',
                                value: 'medium',
                                width: 33
                            },
                            {
                                title: 'Fast',
                                value: 'fast',
                                width: 33
                            },
                        ]
                    },
                    {
                        controlName: 'Slider',
                        property: 'tabsDelay',
                        title: 'Delay',
                        defaultValue: 10,
                        suffix: 's',
                        min: 10,
                        max: 100,
                        step: 5,
                    },
                ],
            },
        ],
        [
            {
                settingName: 'Anchor',
            }
        ]
    ];
    narratorSettings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            }, {
            settingName: 'VerticalAlignment',
        }
        ],
        [
            {
                settingName: 'NarratorContent',
                title: 'Narrator points',
                icon: environmentLink + '/assets/images/tabsContent.svg',
                isShowTitle: false,
                hasDrop: true,
                dropWidth: 'popup',
                removePadding: true,
                controls: [
                    {
                        controlName: 'NarratorContent',
                        property: 'narratorItems',
                        title: 'Narrator points',
                        icon: environmentLink + '/assets/images/tabsContent.svg'
                    },
                ],
            },
            {
                settingName: 'NarratorDesign',
                title: 'Narrator design',
                icon: environmentLink + '/assets/images/tabsDesign.svg',
                isShowTitle: false,
                hasDrop: true,
                dropWidth: 'popup',
                removePadding: true,
                controls: [
                    {
                        controlName: 'NarratorDesign',
                        property: 'narratorType',
                        title: 'Narrator design',
                        icon: environmentLink + '/assets/images/tabsDesign.svg'
                    },
                ],
            },
        ],
        [
            {
                settingName: 'BackgroundColor',
                controls: [
                    {
                        controlName: 'CustomColors',
                        property: 'backgroundColor',
                        title: '',
                        defaultValue: '#fff',
                    },
                ],
            },
            {
                settingName: 'BorderColor',
            },
            {
                settingName: 'BorderWidth',
            },
            {
                settingName: 'BorderRadius',
            },
            {
                settingName: 'ElementWidth',
            },
            {
                settingName: 'ContainerRatio',
                enable: {
                    type: 'combo',
                    values: ['SideBySide', 'Narrator', 'Tabs']
                }
            },
        ],
        [
            {
                settingName: 'Anchor',
            }
        ]
    ];
}

const label: {[key: string]: string} = {
    'SideBySide': 'Side by side',
    'VTimeline': 'Timeline',
    'Array': 'Array',
    'Tabs': 'Tabs',
    'Narrator': 'Narrator',
    'Simple': 'Content block'
}

const options: { [key: string]: Options[] } = {
    'SideBySide': [
        {
            name: 'backgroundColor',
            title: 'Background',
            icon: environmentLink + '/assets/images/Options/color.svg',
            action: 'setActiveSetting',
            settingTitle: 'Background Color',
        }
    ],
    'VTimeline': [
        {
            name: 'comboLineColor',
            title: 'Line',
            icon: environmentLink + '/assets/images/Options/line.svg',
            action: 'setActiveSetting',
            settingTitle: 'Line Color',
        },
        {
            name: 'comboDotsColor',
            title: 'Dot',
            icon: environmentLink + '/assets/images/Options/dot.svg',
            action: 'setActiveSetting',
            settingTitle: 'Dot Color',
        }
    ],
    'Array': [
        {
            name: 'setsPerLine',
            title: 'Layout',
            icon: environmentLink + '/assets/images/Options/layout.svg',
            action: 'setActiveSetting',
            settingTitle: 'Groups per line',
        }
    ],
    'Tabs': [
        {
            name: 'editTabs',
            title: 'Edit',
            icon: environmentLink + '/assets/images/Options/edit.svg',
            action: 'editTabs',
            settingTitle: 'Tabs content',
            condition: 'Tabs'
        },
        {
            name: 'tabsItems',
            title: 'Style',
            icon: environmentLink + '/assets/images/Options/style.svg',
            action: 'setActiveSetting',
            settingTitle: 'Tabs design',
            condition: 'Tabs'
        },
    ],
    'Narrator': [
        {
            name: 'editNarrator',
            title: 'Edit points',
            icon: environmentLink + '/assets/images/Options/narrator.svg',
            action: 'editNarrator',
            settingTitle: 'Narrator points',
            condition: 'Narrator'
        }
    ],
    'Simple': [
        {
            name: 'maxWidth',
            title: 'Width',
            icon: environmentLink + '/assets/images/Options/width.svg',
            action: 'setActiveSetting',
            settingTitle: 'Element Width',
        },
        {
            name: 'maxHeight',
            title: 'Height',
            icon: environmentLink + '/assets/images/Options/height.svg',
            action: 'setActiveSetting',
            settingTitle: 'Element Height',
        }
    ]
}

function getEnvironmentLink() {
    // return "http://localhost:3000";
    if (process.env.PUBLIC_URL.length) return process.env.PUBLIC_URL;
    if (process.env.REACT_APP_ENV === 'staging') return 'https://editor-bundle-staging.storydoc.com'; //staging link
    if (process.env.REACT_APP_ENV === 'production') return 'https://editor-bundle.storydoc.com'; //production link
    if (process.env.REACT_APP_ENV === 'dev') return 'http://localhost:3000'; //production link
}

function getFontSizeValues() {
    let values = [];
    for (let i = 0; i < 63; i++) {
        if (i !== 0 && i > 9 && i % 2 == 0) {
            values.push(i);
        }
    }
    return values;
}
